<template>
  <div class="authenticated-layout">
    <main class="authenticated-main">
      <slot />
    </main>

    <footer class="authenticated-footer">
      <NavigationTabs />
    </footer>
  </div>
</template>

<script>
import NavigationTabs from "./NavigationTabs.vue";
import { createdMixin } from "@monolith/mixins";
import { mapGetters } from "vuex";

export default {
  name: "AuthenticatedLayout",
  components: {
    NavigationTabs,
  },
  mixins: [createdMixin],
  data() {
    return {
      id: null,
      target: null,
      options: {
        enableHighAccuracy: false,
        timeout: 5000,
        maximumAge: 0,
      },
    };
  },

  async mounted() {
    window.addEventListener("offline", () => {
      this.socket.disconnect();
    });
    window.addEventListener("pageHide", () => {
      this.socket.disconnect();
    });
  },
  async beforeUnmount() {
    window.removeEventListener("offline", () => {
      this.socket.disconnect();
    });
    window.removeEventListener("pageHide", () => {
      this.socket.disconnect();
    });
  },

  methods: {},

  computed: {
    ...mapGetters({}),
  },

  watch: {},
};
</script>

<style scoped lang="scss">
@use "@monolith/styles";
.authenticated-layout {
  display: flex;
  flex-direction: column;
  //   min-height: 100vh;
}

.authenticated-main {
  flex: 1;
  padding: 1rem;
  background-color: var(--primary-colour);
}

.authenticated-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
}
</style>
